(function () {
    angular.module('GorillaBoy.services')
    .factory('LayoutManager', [
        '$rootScope',
        '$translate',
        '$routeParams',
        'MessageProvider',
        'SessionManager',
        'SortService',
        'AppConstants',
        'authenticatedUser',
        LayoutManager
    ]);

    function LayoutManager($rootScope, $translate, $routeParams, MessageProvider, SessionManager, SortService, AppConstants, authenticatedUser) {
        var layoutManager = {},
            sidebarLeftScrollPosition = 0;

        // AppConstant bindings
        var viewTypes = AppConstants.ViewTypes,
            PAGE_TITLES = {
                OWN_TYPE: 'TOP_NAV.MY_DOCUMENTS',
                SHARED_TYPE: 'TOP_NAV.SHARED_WITH_ME',
                SHARED_BY_ME_TYPE: 'TOP_NAV.SHARED_BY_ME',
                AWAITING_FEEDBACK_TYPE: 'TOP_NAV.AWAITING_MY_FEEDBACK',
                OUT_FOR_REVIEW_TYPE: 'TOP_NAV.OUT_FOR_REVIEW',
                RECYCLE_TYPE: 'TOP_NAV.RECYCLE_BIN',
                RECOVERY_TYPE: 'TOP_NAV.RECOVERY_BIN',
                NOTE_TYPE: 'TOP_NAV.MYNOTE'
            },
            ICON_FOLDER_OPEN = 'icon-folder-open',
            ICON_FOLDER_CLOSED = 'icon-folder-close',
            ICON_FOLDER_CLOSED_ALT = 'icon-folder-alt',
            ACTIVE_CLASS = 'active',
            INACTIVE_CLASS = '';

        layoutManager.goToParent = function (id, showMyDocs, showRecycleBin) {
            switch (SessionManager.getLastVisited()) {
                case viewTypes.FOLDER_TYPE:
                    $rootScope.showFolder(id);
                    break;
                case viewTypes.OWN_TYPE:
                    $rootScope.showDocs();
                    break;
                case viewTypes.SHARED_TYPE:
                    $rootScope.showShared();
                    break;
                case viewTypes.SHARED_BY_ME_TYPE:
                    $rootScope.showSharedByMe();
                    break;
                case viewTypes.OUT_FOR_REVIEW_TYPE:
                    $rootScope.showReview();
                    break;
                case viewTypes.AWAITING_FEEDBACK_TYPE:
                    $rootScope.showFeedback();
                    break;
                case viewTypes.RECYCLE_TYPE:
                    $rootScope.showRecycle();
                    break;
                case viewTypes.SEARCH_TYPE:
                    $rootScope.showSearch(SessionManager.getLastSearched());
                    break;
                default:
                    $rootScope.showFolder(id, showMyDocs, showRecycleBin);
            }
        };

        layoutManager.is = function (type, $scope, folderId) {

            $scope.pageOwnIcon = (type === viewTypes.OWN_TYPE) ? ICON_FOLDER_OPEN : ICON_FOLDER_CLOSED;
            $scope.pageOwnStyle = (type === viewTypes.OWN_TYPE) ? ACTIVE_CLASS : INACTIVE_CLASS;
            $scope.pageSharedIcon = (type === viewTypes.SHARED_TYPE) ? ICON_FOLDER_OPEN : ICON_FOLDER_CLOSED;
            $scope.pageSharedStyle = (type === viewTypes.SHARED_TYPE) ? ACTIVE_CLASS : INACTIVE_CLASS;
            $scope.pageFeedbackIcon = (type === viewTypes.AWAITING_FEEDBACK_TYPE) ? ICON_FOLDER_OPEN : ICON_FOLDER_CLOSED;
            $scope.pageFeedbackStyle = (type === viewTypes.AWAITING_FEEDBACK_TYPE) ? ACTIVE_CLASS : INACTIVE_CLASS;
            $scope.pageFeedbackOutIcon = (type === viewTypes.OUT_FOR_REVIEW_TYPE) ? ICON_FOLDER_OPEN : ICON_FOLDER_CLOSED;
            $scope.pageFeedbackOutStyle = (type === viewTypes.OUT_FOR_REVIEW_TYPE) ? ACTIVE_CLASS : INACTIVE_CLASS;
            $scope.pageRecycleBinIcon = (type === viewTypes.RECYCLE_TYPE) ? ICON_FOLDER_OPEN : ICON_FOLDER_CLOSED_ALT;
            $scope.pageRecycleBinStyle = (type === viewTypes.RECYCLE_TYPE) ? ACTIVE_CLASS : INACTIVE_CLASS;

            $scope.sortOptions = SortService.getDefaultSortOptions(type);

            function setTitle(data) {
                $scope.pageTitle = data;
                document.title = $scope.pageTitle + ' - ' + AppConstants.APP_NAME;
            }

            switch (type) {
                case viewTypes.FAVORITES:
                    setTitle($translate.instant('FAVORITES.PAGE_TITLE'));
                    $scope.folderState.emptyMessage = $translate.instant('FAVORITES.EMPTY_LIST_SUGGESTION');
                    $scope.isFavorites = false;
                    $scope.isRightClickSupported = true;
                    break;
                case viewTypes.OWN_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.OWN_TYPE));
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = true;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageDocsList;
                    $scope.isRightClickSupported = true;
                    break;
                case viewTypes.SHARED_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.SHARED_TYPE));
                    $scope.isShared = true;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = true;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageShared;
                    $scope.isRightClickSupported = true;
                    break;
                case viewTypes.SHARED_BY_ME_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.SHARED_BY_ME_TYPE));
                    $scope.isShared = true;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = true;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageSharedByMe;
                    $scope.isRightClickSupported = true;
                    break;
                case viewTypes.AWAITING_FEEDBACK_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.AWAITING_FEEDBACK_TYPE));
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = true;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageAwaitingFeedback;
                    $scope.isRightClickSupported = false;
                    break;
                case viewTypes.OUT_FOR_REVIEW_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.OUT_FOR_REVIEW_TYPE));
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = true;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = true;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageOutForReview;
                    $scope.isRightClickSupported = false;
                    break;
                case viewTypes.RECYCLE_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.RECYCLE_TYPE));
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = false;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageRecycleBin;
                    $scope.isRightClickSupported = false;
                    break;
                case viewTypes.RECOVERY_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.RECOVERY_TYPE));
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = false;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageRecoveryBin;
                    $scope.isRightClickSupported = false;
                    break;
                case viewTypes.NOTE_TYPE:
                    setTitle($translate.instant(PAGE_TITLES.NOTE_TYPE));
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = false;
                    $scope.layout.showUploadPane = true;
                    $scope.hasPendingFeedback = false;
                    $scope.isRightClickSupported = false;
                    break;
                case viewTypes.SEARCH_TYPE:
                    $scope.pageTitle = '';
                    $scope.isShared = false;
                    $scope.hasFilters = true;
                    $scope.layout.hasRightSidebar = false;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    $scope.isRightClickSupported = false;
                    break;
                case viewTypes.FOLDER_TYPE:
                    // This is generic case for 'My Documents' and all folders, In
                    // case of folders Page title is set when setting the metadata
                    $scope.pageTitle = '';
                    if (authenticatedUser.getUserInfo().RootFolderId === folderId) {
                        setTitle($translate.instant(PAGE_TITLES.OWN_TYPE));
                        $scope.layout.hasRightSidebar = true;
                    } else if (authenticatedUser.getUserInfo().RecycleBinFolderId === folderId) {
                        setTitle($translate.instant(PAGE_TITLES.RECYCLE_TYPE));
                        $scope.layout.hasRightSidebar = false;
                    }
                    $scope.layout.showRightSidebar = $routeParams.showRightPanel ? true: false;
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageDocsListViewOnly;
                    $scope.isRightClickSupported = true;
                    break;
                default: // Unrecognized type
                    $scope.pageTitle = '';
                    $scope.isShared = false;
                    $scope.hasFilters = false;
                    $scope.layout.hasRightSidebar = false;
                    $scope.layout.showUploadPane = false;
                    $scope.hasPendingFeedback = false;
                    break;
            }
        };

        layoutManager.getSidebarLeftScrollPosition = function () {
            return sidebarLeftScrollPosition;
        };

        layoutManager.setSidebarLeftScrollPosition = function (scrollTop) {
            sidebarLeftScrollPosition = scrollTop;
        };

        layoutManager.resetSidebarLeftScrollPosition = function () {
            sidebarLeftScrollPosition = 0;
        };

        layoutManager.resetRightScrollBarPosition = function () {
            $('.ps-scrollbar-y-rail').css('top', 0);
        };

        return layoutManager;
    }

}());
